export default {
      id: "oc-icon_dropdown-usage",
      viewBox: "0 0 10 11",
      url: __webpack_public_path__ + "sprite.svg#oc-icon_dropdown",
      toString: function () {
        return this.url;
      }
    }